import HttpWrapper from '@/utils/http/httpWrapper'

import ShipbobAppSettings from '../../appSettings/appSetting'

export class SystemSettingsServiceInternal {
  urls () {
    return {
      getSystemSettings: process.env.USE_PHOTOPRINT === '0' ? `${ShipbobAppSettings.shipbobV2Api}/api/systemSettings/get` : `${ShipbobAppSettings.photoPrint}/SystemSetting/GetSetting`
    }
  }

  async get (name) {
    const request = {
      Url: `${this.urls().getSystemSettings}?name=${name}`
    }
    return await HttpWrapper.Get(request, null, null, true)
  }
}

export const SystemSettingsService = new SystemSettingsServiceInternal()
